import _ from 'lodash'

/**
 * Provides authority over search filters on the current state.
 *
 * @type {ngService}
 */
export class TmrSearchFormFilters {
  static ngType = 'service'

  constructor($state, $stateParams, TmrSearchFormFilter) {
    'ngInject'
    Object.assign(this, { $state, $stateParams, TmrSearchFormFilter })
    this._params = {}
  }

  get params() {
    return this.activeParams.reduce((params, param) => {
      params[param] = this.$stateParams[param]
      return params
    }, {})
  }

  get activeParams() {
    return this.extractActiveFiltersFromState()
  }

  get paramsDefinitions() {
    return _.pick(this.$state.current.params, Object.keys(this._params))
  }

  get formatted() {
    let formatted = {}
    this.activeParams
      // Remove parameters that are in url but have no filter.
      .filter(param => this._params[param] !== undefined)
      .forEach(
        param =>
          (formatted[param] = {
            label: this._params[param].label,
            values: this._params[param].formatted,
          })
      )
    return formatted
  }

  get updated() {
    let updated = {}
    for (const param in this._params) {
      if (this._params[param].updated)
        updated[param] = this._params[param].value
    }
    return updated
  }

  register(param, label, value, formatter) {
    this._params[param] = new this.TmrSearchFormFilter(
      param,
      label,
      value,
      formatter
    )
  }

  unregister(param) {
    delete this._params[param]
  }

  update(param, value) {
    Object.assign(this._params[param], { updated: true, value })
  }

  /**
   * UI Router param has two possible forms: param: defaultValue or param: { value: defaultValue }
   */
  getParamDefaultValue(param) {
    return param?.value === undefined ? param : param.value
  }

  /**
   * Extracts default values of search params from current state
   */
  get paramsDefaultValues() {
    let defaults = {}
    Object.keys(this.paramsDefinitions).forEach(
      definition =>
        (defaults[definition] = this.getParamDefaultValue(
          this.paramsDefinitions[definition]
        ))
    )
    return defaults
  }

  /**
   * Extracts a list of active filters from a state/stateParams pair
   * If arguments are not provided, uses current state and stateParams.
   */
  extractActiveFiltersFromState(
    { resourceList, params } = this.$state.current,
    stateParams = this.$stateParams
  ) {
    if (resourceList === undefined) return []
    return resourceList.searchParameters.filter(param => {
      const value = this.getParamDefaultValue(params[param])
      return (
        // There is a value...
        stateParams[param] !== undefined &&
        stateParams[param] !== null &&
        // ...and the value is different from the default value (if any)
        (value === undefined ||
          value === null ||
          !_.isEqual(stateParams[param], value))
      )
    })
  }
}
